module.exports = __webpack_public_path__ + "img/eco-btn-swiper.63c0cd56.png";